<template>
    <CustomHeader/>
</template>

<script>
export default {
  name: 'Header'

}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/layout/home/Header.vue